import React from 'react'
import { Routes, Route } from 'react-router-dom'

// const Home = React.lazy(() => import("@/view/home/index"));
const App = React.lazy(() => import('@/view/app/index'))
// const DownloadList = React.lazy(() => import("@/view/download_list/index"));
const LoadingPage = React.lazy(() => import('@/view/loading/index'))
const WarningPage = React.lazy(() => import('@/view/download_list/warning'))
const InfoPage = React.lazy(() => import('@/view/download_list/info'))
const SelectModel = React.lazy(() => import('@/view/select_model/index'))
const ModelDetail = React.lazy(() => import('@/view/model_detail/index'))
const LanguageShow = React.lazy(() => import('@/view/language_show/index'))
const NoData = React.lazy(() => import('@/view/no_data/index'))
const ChargingPile = React.lazy(() => import('@/view/charging_pile/index'))
const ConnectionGuide = React.lazy(() => import('@/view/connection_guide'))
const ConnectionGuide2025 = React.lazy(
  () => import('@/view/connection_guilde_2025')
)
const BluetoothGuide = React.lazy(
  () => import('@/view/connection_guilde_2025/bluetooth_guide')
)
const PdfPreview = React.lazy(() => import('@/view/pdf_preview'))
const TransferPage = React.lazy(() => import('@/view/transfer_page'))

export default (
  <Routes>
    {/* <Route path="/" element={<DownloadList />} /> */}
    <Route path='/' element={<LoadingPage />} />
    <Route path='/language' element={<LanguageShow />} />
    <Route path='/g/i' element={<LoadingPage />} />
    <Route path='/no_data' element={<NoData />} />
    <Route path='/app_list/:company' element={<InfoPage />} />
    <Route path='/app_list' element={<InfoPage />} />
    <Route path='/g/w' element={<WarningPage />} />
    <Route path='/select_model/:company' element={<SelectModel />} />
    {/* <Route path="/home" element={<Home />} /> */}
    <Route path='/app' element={<App />} />
    <Route path='/g/w' element={<SelectModel />} />
    <Route path='/model_detail/:id/:company' element={<ModelDetail />} />
    <Route path='/charging_pile' element={<ChargingPile />} />
    <Route path='/conncection_guide' element={<ConnectionGuide />} />
    <Route path='/conncection_guide_2025' element={<ConnectionGuide2025 />} />
    <Route path='/bluetooth_guide_2025' element={<BluetoothGuide />} />
    <Route path='/pdfPreview' element={<PdfPreview />} />
    <Route path='/transferPage' element={<TransferPage />} />
    <Route path='/transferPage/:appKey' element={<TransferPage />} />
  </Routes>
)
